(function () {
  'use strict';

  class YGVideoBanner extends HTMLElement {
    constructor() {
      super();
      this.hasAnimated = false;
      this.handleResize = this.handleResize.bind(this);
      this.currentMode = null; // 'pc' | 'mobile'
    }

    connectedCallback() {
      this.initElements();

      // 首帧延迟执行，避免 width 判断错误
      requestAnimationFrame(() => {
        this.updateVideo();
      });

      window.addEventListener('resize', this.handleResize);

      if (this.dataset.animation === 'true') {
        this.initAnimationWhenReady();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }

    /* ----------------------------
     * 初始化 DOM
     * ---------------------------- */
    initElements() {
      this.pcMedia = this.querySelector('.pc-media');
      this.mobileMedia = this.querySelector('.mobile-media');
      this.pcVideo = this.querySelector('.pc-video');
      this.mobileVideo = this.querySelector('.mobile-video');

      // 禁止默认加载（关键！）
      if (this.pcVideo) this.pcVideo.preload = 'none';
      if (this.mobileVideo) this.mobileVideo.preload = 'none';
    }

    /* ----------------------------
     * 更稳定的设备判断
     * ---------------------------- */
    get isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    get mode() {
      return this.isMobile ? 'mobile' : 'pc';
    }

    /* ----------------------------
     * resize 时切换
     * ---------------------------- */
    handleResize() {
      const newMode = this.mode;
      if (newMode !== this.currentMode) {
        this.updateVideo();
      }
    }

    /* ----------------------------
     * 核心：只加载当前 video
     * ---------------------------- */
    updateVideo() {
      const mode = this.mode;
      this.currentMode = mode;

      const activeVideo = mode === 'mobile' ? this.mobileVideo : this.pcVideo;
      const inactiveVideo = mode === 'mobile' ? this.pcVideo : this.mobileVideo;

      const activeMedia = mode === 'mobile' ? this.mobileMedia : this.pcMedia;
      const inactiveMedia = mode === 'mobile' ? this.pcMedia : this.mobileMedia;

      // 停止并清理 inactive video（关键）
      if (inactiveVideo) {
        inactiveVideo.pause();
        inactiveVideo.removeAttribute('src');
        inactiveVideo.load();
      }

      if (!activeVideo) return;

      // 如果还没加载 source，则创建
      if (!activeVideo.querySelector('source')) {
        const source = document.createElement('source');

        // ⚠️ 这里依赖你 HTML 写 data-src
        const src = activeVideo.dataset.src;
        if (!src) return;

        source.src = src;
        source.type = 'video/mp4';
        activeVideo.appendChild(source);
      }

      // 设置属性
      activeVideo.muted = true;
      activeVideo.autoplay = true;
      activeVideo.loop = true;
      activeVideo.playsInline = true;
      activeVideo.preload = 'metadata';

      const play = () => {
        activeVideo.play().catch(() => {});
      };

      // ready 处理
      if (activeVideo.readyState >= 2) {
        this.markReady(activeMedia);
        play();
      } else {
        const onLoaded = () => {
          this.markReady(activeMedia);
          play();
          activeVideo.removeEventListener('loadeddata', onLoaded);
        };

        activeVideo.addEventListener('loadeddata', onLoaded, { once: true });
        activeVideo.load();
      }

      // 清理 inactive 样式
      if (inactiveMedia) {
        inactiveMedia.classList.remove('is-video-ready');
      }
    }

    markReady(media) {
      if (!media) return;
      media.classList.add('is-video-ready');
    }

    /* ----------------------------
     * 动画（保持你原逻辑）
     * ---------------------------- */
    initAnimationWhenReady() {
      if (typeof gsap !== 'undefined') {
        this.initAnimation();
        return;
      }

      const timer = setInterval(() => {
        if (typeof gsap !== 'undefined') {
          clearInterval(timer);
          this.initAnimation();
        }
      }, 100);
    }

    initAnimation() {
      if (this.hasAnimated) return;
      this.hasAnimated = true;

      const title = this.querySelector('.scene-v2-header-banner-content-title');
      const description = this.querySelector('.scene-v2-header-banner-content-description');

      if (!title || !description) return;

      title.style.willChange = 'transform, opacity';
      description.style.willChange = 'transform, opacity';

      gsap.set([title, description], { opacity: 0, y: 40 });

      const tl = gsap.timeline({
        onComplete: () => {
          title.style.willChange = 'auto';
          description.style.willChange = 'auto';
        }
      });

      tl.to(title, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out'
      }, 0.4);

      tl.to(description, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out'
      }, 0.6);
    }
  }

  if (!window.customElements.get('yg-video-banner')) {
    window.customElements.define('yg-video-banner', YGVideoBanner);
  }
})();